import React, { useState } from "react";
import { Share2, Copy, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const TEXT = "جرّب رواج الذكية — منصة سعودية تبني استراتيجيتك التسويقية وتولّد صوراً وفيديوهات احترافية لعلامتك بالذكاء الاصطناعي";

export function PublicShareButton() {
  const [open, setOpen] = useState(false);
  const link = window.location.origin;
  const msg = `${TEXT}\n${link}`;

  const onClick = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "رواج الذكية", text: TEXT, url: link }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    setOpen(true);
  };
  const copy = async () => { try { await navigator.clipboard.writeText(link); toast.success("تم نسخ الرابط ✅"); } catch { toast.error("انسخ الرابط يدوياً"); } };

  return (
    <>
      <Button onClick={onClick} variant="outline" className="rounded-full border-primary/40 bg-secondary/80 text-primary hover:border-primary hover:bg-secondary gap-1.5 h-9 px-3" data-testid="public-share-btn" title="شارك رواج الذكية">
        <Share2 className="w-4 h-4" /> <span className="hidden sm:inline">{localStorage.getItem("rawaj_lang") === "en" ? "Share" : "شارك"}</span>
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-popover border-border max-w-sm" dir="rtl" data-testid="public-share-dialog">
          <DialogHeader>
            <DialogTitle className="text-start">شارك رواج الذكية</DialogTitle>
            <DialogDescription className="text-start">انشر رواج الذكية مع أصحاب المشاريع من حولك</DialogDescription>
          </DialogHeader>
          <div className="flex items-center gap-2 border border-border rounded-xl px-3 py-2 bg-secondary">
            <span className="text-xs font-mono truncate flex-1" dir="ltr" data-testid="public-share-link">{link}</span>
            <button onClick={copy} className="text-primary" data-testid="public-share-copy"><Copy className="w-4 h-4" /></button>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <a href={`https://wa.me/?text=${encodeURIComponent(msg)}`} target="_blank" rel="noopener noreferrer" data-testid="public-share-whatsapp">
              <Button className="w-full bg-emerald-600 hover:bg-emerald-700 text-white gap-2"><Send className="w-4 h-4" /> واتساب</Button>
            </a>
            <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(msg)}`} target="_blank" rel="noopener noreferrer" data-testid="public-share-x">
              <Button variant="outline" className="w-full border-border">X / تويتر</Button>
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
